import EmployeeBasicInfo from "./EmployeeBasicInfo";

export default EmployeeBasicInfo;
